import { groupApi as groupApiUrl } from '../../utils/urls';
import { rootApi } from '../../services/rootApi';

export const groupsApiSlice = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchEditableGroups: builder.query({
      query: ({ disableCounts }) => ({
        url: groupApiUrl(),
        method: 'POST',
        body: {
          data: { disableCounts },
          method: 'findBuildable'
        },
      }),
      transformResponse: (response) => response.data,
      providesTags: (result) => [
        { type: 'GroupList', id: 'EDITABLE' },
        ...(result ?? []).map((group) => ({ type: 'Group', id: group.id })),
      ],
    }),
    fetchGroupById: builder.query({
      query: ({ id, withCounts }) => ({
        url: groupApiUrl(),
        method: 'POST',
        body: {
          data: { withCounts, id },
          method: 'findById'
        },
      }),
      transformResponse: (response) => response.data,
      providesTags: (result, error, { id }) => [{ type: 'Group', id }],
    }),
    createGroup: builder.mutation({
      query: (name) => ({
        url: groupApiUrl(),
        method: 'POST',
        body: {
          data: { name },
          method: 'create'
        },
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: [{ type: 'GroupList', id: 'EDITABLE' }],
    }),
    deleteGroup: builder.mutation({
      query: (id) => ({
        url: groupApiUrl(),
        method: 'POST',
        body: {
          data: { id },
          method: 'delete'
        },
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: [{ type: 'GroupList', id: 'EDITABLE' }],
    }),
    addGroupToCourse: builder.mutation({
      query: ({ circleId, ucpPeriod, courseIds }) => ({
        url: groupApiUrl(),
        method: 'POST',
        body: {
          data: { circleId, ucpPeriod, courseIds },
          method: 'addToCourse'
        },
      }),
      transformResponse: (response) => response.data,
      transformErrorResponse: (response) => {
        if (response.status === 'PARSING_ERROR' && response.data && typeof response.data === 'string') {
          return { error: 'Server returned invalid response format' };
        }
        return response;
      },
      invalidatesTags: (result, error, { circleId }) => [
        { type: 'GroupList', id: 'EDITABLE' }, 
        { type: 'Courses', id: circleId },
        { type: 'Courses', id: 'LIST' }
      ],
    }),
    removeGroupFromCourse: builder.mutation({
      query: ({ courseId, circleId }) => ({
        url: groupApiUrl(),
        method: 'POST',
        body: {
          data: {
            courseId,
            circleId
          },
          method: 'removeFromCourse'
        },
      }),
      transformResponse: (response) => response.data,
      transformErrorResponse: (response) => {
        if (response.status === 'PARSING_ERROR' && response.data && typeof response.data === 'string') {
          return { error: 'Server returned invalid response format' };
        }
        return response;
      },
      invalidatesTags: (result, error, { circleId }) => [
        { type: 'GroupList', id: 'EDITABLE' }, 
        { type: 'Courses', id: circleId },
        { type: 'Courses', id: 'LIST' }
      ],
    }),
    updateGroupName: builder.mutation({
      query: ({ id, name }) => ({
        url: groupApiUrl(),
        method: 'POST',
        body: {
          data: {
            id,
            name
          },
          method: 'update'
        },
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: (result, error, { id }) => [
        { type: 'GroupList', id: 'EDITABLE' },
        { type: 'Group', id }
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useFetchEditableGroupsQuery,
  useFetchGroupByIdQuery,
  useCreateGroupMutation,
  useDeleteGroupMutation,
  useAddGroupToCourseMutation,
  useRemoveGroupFromCourseMutation,
  useUpdateGroupNameMutation,
} = groupsApiSlice; 